// extracted by mini-css-extract-plugin
export default {"inputBox":"input_inputBox__qx635","label":"input_label__TmugR","icon":"input_icon__nhdI+","input":"input_input__41e3r","container":"input_container__lAuqx"};